import { IProduct } from "../type/IProduct";
import { IProductHashtagMap } from "../type/IProductHashtagMap";

export const getRelatedProductsOfProduct = (product: IProduct, productHashtagMap: IProductHashtagMap): IProduct[] => {
  if (!product) return [];

  const { hashtags } = product.metadata;
  if (!hashtags) return [];

  const productMap = productHashtagMap[hashtags[0]];

  if (!productMap) return [];

  return Object.values(productMap).filter((p) => product.id !== p.id);
}
